module.exports = __webpack_public_path__ + "img/z-score-chart.5f6b1922.svg";